import { useObserver } from "mobx-react";
import React, { useState } from "react";
import { MdClose } from "react-icons/md";
import userprofiledefaultpic from "../../assests/userprofiledefaultpic.jpg";
import { useStores } from "../../store";
import { useNavigate } from "react-router-dom";
import { toJS } from "mobx";

export default function AssessmentCard() {
  const [isVisible, setIsVisible] = useState(true);
  const { RecuiterStore } = useStores();
  const convertTimestampToDate = (timestamp) => {
    const date = new Date(timestamp); // Convert milliseconds to Date object
    const options = { year: "2-digit", month: "short", day: "2-digit" };
    return date.toLocaleDateString("en-GB", options).replace(/ /g, "-");
  };

  const handleClose = () => {
    RecuiterStore.latestActivityVisible = false;
    RecuiterStore.closeActivity = true;
  };
  const navigate = useNavigate();

  const handleViewDetails = () => {
    console.log(toJS(RecuiterStore?.latestActivity));
    if (RecuiterStore?.latestActivity?.type === "interview") {
      localStorage.setItem("interviewId", RecuiterStore?.latestActivity?._id);
      RecuiterStore?.setApplicantSkip(0);
      navigate(`/company/applicants`);
    } else if (RecuiterStore?.latestActivity?.type === "mocktest") {
      navigate(`/recruiter/assessment/${RecuiterStore?.latestActivity?.id}`);
    } else if (
      RecuiterStore?.latestActivity?.type === "jobPost" ||
      RecuiterStore?.latestActivity?.type === "jobpost"
    ) {
      localStorage.setItem("jobId", RecuiterStore?.latestActivity?._id);
      navigate(`/company/job-applicants/${RecuiterStore?.latestActivity?._id}`);
    } else if (RecuiterStore?.latestActivity?.type === "resumeSorting") {
      navigate(`/company/resumescore/${RecuiterStore?.latestActivity?._id}`);
    }
  };

  return useObserver(() => (
    <div className="relative bg-black text-white p-4 rounded-lg shadow-lg sm:w-auto w-[95%] mx-auto">
      <button
        onClick={handleClose}
        className="absolute -top-2 -right-1 text-white bg-primary  hover:bg-gray-600 rounded-full p-1"
      >
        <MdClose />
      </button>
      <span className="flex justify-between items-center w-[98%]">
        <h1 className="pb-2 gil-med">New Assessment</h1>
        <button
          className="bg-primary flex gap-1 md:-mr-5 items-center text-white rounded-lg px-2 py-1  my-1 -mt-2.5 text-xs "
          onClick={handleViewDetails}
        >
          View Details
        </button>
      </span>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-4 items-center border-t border-opacity-90 border-dashed pt-2">
        {/* First Row: Assessment Name and Assessment Type Side by Side */}
        <div className="col-span-1">
          <p className="text-[#F3DEBE] gil-med">Assessment type</p>
          <p className="mt-1 text-sm gil-med capitalize">
            {RecuiterStore?.latestActivity?.type}
          </p>
        </div>
        <div className="col-span-1">
          <p className="text-[#F3DEBE] gil-med">Name of the Assessment</p>
          <p className="mt-1 text-sm capitalize gil-med">
            {RecuiterStore?.latestActivity?.title?.length > 0
              ? RecuiterStore?.latestActivity?.title
              : "HR Interview"}
          </p>
        </div>

        {/* Second Row: Created On and Average Credit Consumption Side by Side */}
        <div className="col-span-1">
          <p className="text-[#F3DEBE] gil-med">Created On</p>
          <p className="mt-1 text-sm gil-med">
            {convertTimestampToDate(RecuiterStore?.latestActivity?.createdAt)}
          </p>
        </div>
        <div className="col-span-1">
          <p className="text-[#F3DEBE] gil-med">Recent Applicant</p>
          <p className="mt-1 text-sm gil-med">
            {RecuiterStore?.latestActivity?.applicants?.length > 0
              ? convertTimestampToDate(
                  RecuiterStore.latestActivity.applicants[0].createdAt,
                )
              : "--"}
          </p>
        </div>

        {/* Third Row: Total Applicants */}
        <div className="col-span-2 sm:col-span-1">
          <p className="text-[#F3DEBE] gil-med">Total Applicants</p>
          <div className="mt-1 text-sm flex items-center gap-2">
            <p className="text-sm flex gap-3 items-center">
              <span className="flex items-center">
                {[
                  ...Array(
                    Math.min(
                      3,
                      RecuiterStore?.latestActivity?.totalApplicants || 0,
                    ),
                  ),
                ].map((_, index) => (
                  <img
                    key={index}
                    src={
                      RecuiterStore?.latestActivity?.applicants?.[index]?.pic ||
                      userprofiledefaultpic
                    }
                    alt="user"
                    className={`w-6 h-6 border-2 border-[#000000] rounded-full ${
                      index > 0 ? "-ml-2" : ""
                    }`}
                  />
                ))}
              </span>
              {(RecuiterStore?.latestActivity?.totalApplicants ?? 0) > 3
                ? `+${(RecuiterStore?.latestActivity?.totalApplicants ?? 0) - 3}`
                : ""}
            </p>
          </div>
        </div>
      </div>
    </div>
  ));
}
